module.exports = __webpack_public_path__ + "img/park.5bf4c8b2.png";